import { render, staticRenderFns } from "./addGrade.vue?vue&type=template&id=227ef1b4&scoped=true&"
import script from "./addGrade.vue?vue&type=script&lang=js&"
export * from "./addGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ef1b4",
  null
  
)

export default component.exports